var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15.1666H5.99992C2.37992 15.1666 0.833252 13.6199 0.833252 9.99992V5.99992C0.833252 2.37992 2.37992 0.833252 5.99992 0.833252H9.33325C9.60658 0.833252 9.83325 1.05992 9.83325 1.33325C9.83325 1.60659 9.60658 1.83325 9.33325 1.83325H5.99992C2.92658 1.83325 1.83325 2.92658 1.83325 5.99992V9.99992C1.83325 13.0733 2.92658 14.1666 5.99992 14.1666H9.99992C13.0733 14.1666 14.1666 13.0733 14.1666 9.99992V6.66658C14.1666 6.39325 14.3933 6.16658 14.6666 6.16658C14.9399 6.16658 15.1666 6.39325 15.1666 6.66658V9.99992C15.1666 13.6199 13.6199 15.1666 9.99992 15.1666Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.16658H11.9999C9.71992 7.16658 8.83325 6.27991 8.83325 3.99991V1.33324C8.83325 1.13324 8.95325 0.946578 9.13992 0.873244C9.32659 0.793244 9.53992 0.839911 9.68659 0.979911L15.0199 6.31324C15.1599 6.45324 15.2066 6.67324 15.1266 6.85991C15.0466 7.04658 14.8666 7.16658 14.6666 7.16658ZM9.83325 2.53991V3.99991C9.83325 5.71991 10.2799 6.16658 11.9999 6.16658H13.4599L9.83325 2.53991Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 9.16675H4.66675C4.39341 9.16675 4.16675 8.94008 4.16675 8.66675C4.16675 8.39341 4.39341 8.16675 4.66675 8.16675H8.66675C8.94008 8.16675 9.16675 8.39341 9.16675 8.66675C9.16675 8.94008 8.94008 9.16675 8.66675 9.16675Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 11.8333H4.66675C4.39341 11.8333 4.16675 11.6066 4.16675 11.3333C4.16675 11.0599 4.39341 10.8333 4.66675 10.8333H7.33341C7.60675 10.8333 7.83341 11.0599 7.83341 11.3333C7.83341 11.6066 7.60675 11.8333 7.33341 11.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c423ca135f5884263f9c4b1dacac9773.svg";
export { ForwardRef as ReactComponent };